import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Shared from "@/components/features/items/discount/_shared";
import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { DISCOUNT_DELETE_FOR_DISCOUNT_LIST_MUTATION } from "./schema";

export const useDiscountDeleteMutation = (hotelID: string) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(DISCOUNT_DELETE_FOR_DISCOUNT_LIST_MUTATION);

	const onDeleteDiscount = useCallback(
		async (discountId: string) => {
			if (
				!window.confirm(
					"本当に削除しますか？\n既存予約で不具合が生じる可能性があります。詳細画面から非公開にすることもできます。",
				)
			) {
				return;
			}

			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { hotelID, discountId },
				refetchQueries: [
					{
						query: Shared.Model.Repository.Query.DISCOUNT_LIST_FOR_DISCOUNT_QUERY,
						variables: { hotelID },
					},
				],
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "ディスカウントを削除しました",
				});
			}
		},
		[hideLoadingScreenCallback, hotelID, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onDeleteDiscount,
	};
};
